import { i18n } from "@lingui/core";
import { messages as enMessages } from "./locales/en/messages";

// Synchronously activate English to prevent I18nProvider warning
// The context will update to the correct locale asynchronously if needed
i18n.load("en", enMessages);
i18n.activate("en");

console.log("initialized i18n");

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA4_ID);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
